import * as React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";

function MapPinIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 100 100">
      <path
        d="M46.5906 95.1234L45.7146 93.7801C31.6907 72.2952 15.7905 47.9486 15.7905 30.8366C15.7905 13.7246 29.6247 0 46.6271 0C63.6296 0 77.4638 13.8341 77.4638 30.8366C77.4638 44.9628 67.6667 65.5643 47.5178 93.8166L46.5833 95.1234H46.5906ZM46.6271 2.1901C30.8292 2.1901 17.9806 15.0387 17.9806 30.8366C17.9806 46.6345 33.0339 70.3387 46.671 91.2323C65.9219 64.0459 75.281 44.2765 75.281 30.8366C75.281 15.0387 62.4324 2.1901 46.6344 2.1901H46.6271Z"
        fill={props.fill || "#164393"}
      />
      <path
        d="M46.6272 53.0515C34.7349 53.0515 25.0547 43.3786 25.0547 31.479C25.0547 19.5795 34.7276 9.90656 46.6272 9.90656C58.5267 9.90656 68.1997 19.5795 68.1997 31.479C68.1997 43.3786 58.5267 53.0515 46.6272 53.0515ZM46.6272 12.104C35.9395 12.104 27.2448 20.7987 27.2448 31.4864C27.2448 42.174 35.9395 50.8687 46.6272 50.8687C57.3149 50.8687 66.0096 42.174 66.0096 31.4864C66.0096 20.7987 57.3149 12.104 46.6272 12.104Z"
        fill={props.fill || "#164393"}
      />
    </SvgIcon>
  );
}

export { MapPinIcon };
